import "./App.css";
import SortingVisualiser from "./components/SortingVisualiser";

function App() {
  return (
    <div className="App">
      <SortingVisualiser />
    </div>
  );
}

export default App;
